var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBilling = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.153 3.32H6A2.57 2.57 0 0 0 3.43 5.891v12.215c0 .834.397 1.576 1.013 2.045l.93-1.462a.85.85 0 0 1-.229-.583V5.89c0-.473.384-.857.857-.857h8.062zm-2.864 4.5L11.2 9.534H8.571a.857.857 0 1 1 0-1.714zm-2.182 3.428-1.09 1.715h-.445a.857.857 0 0 1 0-1.714zm3.65 1.715 1.092-1.714h.58a.857.857 0 0 1 0 1.714zm-2.181 3.428 1.09-1.714h2.763a.857.857 0 1 1 0 1.714zM9.94 18.963H18a.857.857 0 0 0 .857-.857V5.89a.85.85 0 0 0-.228-.582l.93-1.463a2.57 2.57 0 0 1 1.013 2.045v12.215A2.57 2.57 0 0 1 18 20.677H8.85z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.456.283a.85.85 0 0 1 .261 1.173l-14 22a.85.85 0 0 1-1.434-.912l14-22a.85.85 0 0 1 1.173-.261",
  clipRule: "evenodd"
})));
export default SvgBilling;